import { AxiosResponse } from "axios";
import { request } from "@utils";
import { PaginatedUnits, UnitRead, UnitPayload } from "@types";

export const getAllUnits = (
  page: number,
): Promise<AxiosResponse<PaginatedUnits>> => {
  const req = request();
  return req.get(`/api/v1/units/paginated?page=${page}&limit=10`);
};

export const updateUnit = async (
  id: string,
  data: UnitPayload,
): Promise<UnitRead> => {
  const res = await request().put(`/api/v1/units/${id}`, data);
  return res.data;
};

export const getUnitsByLocation = (
  locationId?: string,
  page: number = 1,
  limit?: number,
): Promise<AxiosResponse<PaginatedUnits>> => {
  if (!locationId) {
    return Promise.reject(new Error("LocationId is required"));
  }

  const req = request();

  if (limit === undefined) {
    return req.get(`/api/v1/locations/${locationId}/units`);
  }

  return req.get(
    `/api/v1/locations/paginated/${locationId}/units?page=${page}&limit=${limit}`,
  );
};

export const getUnitsByStatus = (
  status: string,
  page: number = 1,
): Promise<AxiosResponse<PaginatedUnits>> => {
  const req = request();
  return req.get(
    `/api/v1/units/paginated?status=${status}&page=${page}&limit=10`,
  );
};

export const getUnitsFiltered = (
  page: number = 1,
  filters: { status?: string; locationId?: string } = {},
): Promise<AxiosResponse<PaginatedUnits>> => {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", "10");
  if (filters.status) params.set("status", filters.status);
  if (filters.locationId) params.set("locationId", filters.locationId);
  const req = request();
  return req.get(`/api/v1/units/paginated?${params.toString()}`);
};
